import React from 'react';

import { observer } from 'mobx-react';

import { LanguageSelect } from 'bringg-web/components/language-select';
import { useStores } from '../../../recipes';

interface Props {
	selectedLanguageCode: string;
	setLang: (code: string) => void;
}

const DEFAULT_LANG = 'en';

const CustomerRatingHeader = observer(({ selectedLanguageCode, setLang }: Props) => {
	const { notificationTemplatesStore } = useStores();

	const ratingReasonLanguages = notificationTemplatesStore.ratingReasonLanguages;
	let availableLanguages = notificationTemplatesStore.availableLanguages;

	availableLanguages = availableLanguages.map(language => ({
		...language,
		hasTemplates: ratingReasonLanguages.includes(language.code)
	}));

	return (
		<div className="customer-rating-header">
			<LanguageSelect
				selectedLanguageCode={selectedLanguageCode}
				defaultLanguageCode={DEFAULT_LANG}
				availableLanguages={availableLanguages}
				selectedLanguageCodeFunc={setLang}
			/>
		</div>
	);
});

export default CustomerRatingHeader;
